import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import './FaqAyudaPage.css';

const FAQ_ITEMS = [
  {
    id: 'pago',
    question: '¿Cómo sé que mi pago fue aprobado?',
    answer: (
      <>
        <p>
          Tras pagar con Wompi (tarjeta, PSE, Bancolombia, Nequi u otro método), verás la pantalla de pedido
          confirmado en Javiland. También recibirás un correo desde <strong>ventas@javiland.com</strong> con el
          asunto «Pago Confirmado».
        </p>
        <p>Wompi puede enviarte su propio comprobante; el de Javiland confirma que registramos tu pedido.</p>
      </>
    )
  },
  {
    id: 'envio',
    question: '¿Cuánto tarda mi pedido y cómo hago seguimiento?',
    answer: (
      <>
        <p>
          Preparamos tu pedido en <strong>1–2 días hábiles</strong>. El tiempo de entrega depende de tu ciudad
          (referencia: ciudades principales 2–4 días hábiles tras el despacho).
        </p>
        <p>
          Cuando despachemos, te enviaremos un correo con el <strong>número de guía</strong>. Si no lo ves,
          revisa spam y la carpeta de promociones.
        </p>
      </>
    )
  },
  {
    id: 'pedido',
    question: '¿Dónde veo el detalle de lo que compré?',
    answer: (
      <>
        <p>
          En la pantalla de confirmación del checkout, pulsa <strong>Ver detalle del pedido</strong>. Ahí verás
          productos, total y dirección de envío.
        </p>
        <p>El mismo detalle va en el correo de pago confirmado. Guarda tu número de pedido (ej. JAV-20260608-XXXX).</p>
      </>
    )
  },
  {
    id: 'devolucion',
    question: '¿Puedo devolver o cambiar un producto?',
    answer: (
      <>
        <p>
          Sí, según nuestra política de devoluciones para productos naturales y de bienestar: plazo de{' '}
          <strong>30 días</strong>, producto sin abrir y empaque sellado (salvo defecto o daño en transporte).
        </p>
        <p>
          Consulta el proceso completo en{' '}
          <a href="/refund-policy">Política de devoluciones</a> o solicítalo desde el formulario de esa página.
        </p>
      </>
    )
  },
  {
    id: 'factura',
    question: '¿Recibo factura electrónica?',
    answer: (
      <>
        <p>
          Sí. Tras confirmar el pago generamos la factura con los datos de identificación que indicaste en el
          checkout. La gestión contable se realiza a través de nuestro sistema Numbers conforme a la normativa
          colombiana.
        </p>
      </>
    )
  },
  {
    id: 'contacto',
    question: '¿Aún necesito ayuda?',
    answer: (
      <>
        <p>
          Escríbenos a <a href="mailto:support@javiland.com">support@javiland.com</a> o{' '}
          <a href="mailto:ventas@javiland.com">ventas@javiland.com</a> con tu número de pedido y una breve
          descripción.
        </p>
        <p>
          También puedes usar el <a href="/contacto">formulario de contacto</a> si prefieres.
        </p>
      </>
    )
  }
];

const FaqAyudaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.history.pushState({}, '', '/');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <div className="faq-ayuda-page">
      <Header />
      <main className="faq-ayuda-main">
        <div className="faq-ayuda-container">
          <header className="faq-ayuda-header">
            <button type="button" className="faq-back-button" onClick={goBack}>
              <i className="fas fa-arrow-left" aria-hidden="true" />
              Volver
            </button>
            <span className="faq-tag">AYUDA</span>
            <h1>Preguntas frecuentes</h1>
            <p>Compras en la tienda Javiland: pagos, envíos, pedidos y devoluciones.</p>
          </header>

          <div className="faq-ayuda-list">
            {FAQ_ITEMS.map((item) => (
              <details key={item.id} className="faq-item" name="javiland-faq">
                <summary>{item.question}</summary>
                <div className="faq-answer">{item.answer}</div>
              </details>
            ))}
          </div>

          <p className="faq-footer-note">
            ¿Tu caso no está aquí?{' '}
            <a href="/contacto">Contáctanos</a> — respondemos en menos de 24 horas hábiles.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FaqAyudaPage;
